/* eslint-disable @stylistic/brace-style */
import { optionsProxy } from '@vlabs/uikit';
import i18n from 'i18next';

export const FACE_QUALITY_IMAGE_FORMAT = optionsProxy.create([
  { value: 'JPEG', get label() { return i18n.t('constants:image_format.JPEG'); } },
  { value: 'JPEG2000', get label() { return i18n.t('constants:image_format.JPEG2000'); } },
  { value: 'PNG', get label() { return i18n.t('constants:image_format.PNG'); } },
]);

export const FACE_QUALITY_GLASSES = optionsProxy.create([
  { value: 'no_glasses', get label() { return i18n.t('constants:glasses.no_glasses'); } },
  { value: 'eyeglasses', get label() { return i18n.t('constants:glasses.eyeglasses'); } },
  { value: 'sunglasses', get label() { return i18n.t('constants:glasses.sunglasses'); } },
]);

export const FACE_QUALITY_SHOULDERS_POSITION = optionsProxy.create([
  { value: 'parallel', get label() { return i18n.t('constants:shoulders_position.parallel'); } },
  { value: 'hidden', get label() { return i18n.t('constants:shoulders_position.hidden'); } },
  { value: 'non-parallel', get label() { return i18n.t('constants:shoulders_position.non-parallel'); } },
]);

export const FACE_QUALITY_EYE = optionsProxy.create([
  { value: 'open', get label() { return i18n.t('constants:eye.open'); } },
  { value: 'occluded', get label() { return i18n.t('constants:eye.occluded'); } },
  { value: 'closed', get label() { return i18n.t('constants:eye.closed'); } },
]);

export const FACE_QUALITY_EYEBROWS_STATE = optionsProxy.create([
  { value: 'neutral', get label() { return i18n.t('constants:eyebrows_state.neutral'); } },
  { value: 'squinting', get label() { return i18n.t('constants:eyebrows_state.squinting'); } },
  { value: 'frowning', get label() { return i18n.t('constants:eyebrows_state.frowning'); } },
  { value: 'raised', get label() { return i18n.t('constants:eyebrows_state.raised'); } },
]);

export const FACE_QUALITY_HEADWEAR_TYPE = optionsProxy.create([
  { value: 'none', get label() { return i18n.t('constants:headwear_type.none'); } },
  { value: 'baseball_cap', get label() { return i18n.t('constants:headwear_type.baseball_cap'); } },
  { value: 'beanie', get label() { return i18n.t('constants:headwear_type.beanie'); } },
  { value: 'peaked_cap', get label() { return i18n.t('constants:headwear_type.peaked_cap'); } },
  { value: 'shawl', get label() { return i18n.t('constants:headwear_type.shawl'); } },
  { value: 'hat_with_earflaps', get label() { return i18n.t('constants:headwear_type.hat_with_earflaps'); } },
  { value: 'helmet', get label() { return i18n.t('constants:headwear_type.helmet'); } },
  { value: 'hood', get label() { return i18n.t('constants:headwear_type.hood'); } },
  { value: 'hat', get label() { return i18n.t('constants:headwear_type.hat'); } },
  { value: 'other', get label() { return i18n.t('constants:headwear_type.other'); } },
]);

export const FACE_QUALITY_SMILE_PROPERTIES = optionsProxy.create([
  { value: 'none', get label() { return i18n.t('constants:smile_properties.none'); } },
  { value: 'smile_lips', get label() { return i18n.t('constants:smile_properties.smile_lips'); } },
  { value: 'smile_teeth', get label() { return i18n.t('constants:smile_properties.smile_teeth'); } },
]);

export const FACE_QUALITY_FACE_COLOR_TYPES = optionsProxy.create([
  { value: 'color', get label() { return i18n.t('constants:face_color_type.color'); } },
  { value: 'grayscale', get label() { return i18n.t('constants:face_color_type.grayscale'); } },
  { value: 'infrared', get label() { return i18n.t('constants:face_color_type.infrared'); } },
]);

export const FACE_QUALITY_YES_NO = optionsProxy.create([
  { value: 0, get label() { return i18n.t('constants:да нет.0'); } },
  { value: 1, get label() { return i18n.t('constants:да нет.1'); } },
]);

export const POLICIES = {
  CALLBACK: {
    type: optionsProxy.create([
      { value: 'http', get label() { return i18n.t('constants:http'); } },
    ]),
    authorization: {
      type: optionsProxy.create([
        { value: 'basic', get label() { return i18n.t('constants:basic'); } },
      ]),
    },
    params: {
      content_type: optionsProxy.create([
        { value: 'application/json', get label() { return i18n.t('constants:application/json'); } },
        { value: 'application/msgpack', get label() { return i18n.t('constants:application/msgpack'); } },
      ]),
    },
  },
  TTL: optionsProxy.create([
    { value: null, get label() { return i18n.t('constants:ttl.null'); } },
    { value: -1, get label() { return i18n.t('constants:ttl.infinite'); } },
    { value: 1, get label() { return i18n.t('constants:ttl.key', { count: 1 }); } },
    { value: 2, get label() { return i18n.t('constants:ttl.key', { count: 2 }); } },
    { value: 3, get label() { return i18n.t('constants:ttl.key', { count: 3 }); } },
    { value: 4, get label() { return i18n.t('constants:ttl.key', { count: 4 }); } },
    { value: 5, get label() { return i18n.t('constants:ttl.key', { count: 5 }); } },
    { value: 6, get label() { return i18n.t('constants:ttl.key', { count: 6 }); } },
    { value: 7, get label() { return i18n.t('constants:ttl.key', { count: 7 }); } },
    { value: 14, get label() { return i18n.t('constants:ttl.key', { count: 14 }); } },
    { value: 30, get label() { return i18n.t('constants:ttl.key', { count: 30 }); } },
    { value: 60, get label() { return i18n.t('constants:ttl.key', { count: 60 }); } },
    { value: 90, get label() { return i18n.t('constants:ttl.key', { count: 90 }); } },
    { value: 180, get label() { return i18n.t('constants:ttl.key', { count: 180 }); } },
    { value: 365, get label() { return i18n.t('constants:ttl.key', { count: 360 }); } },
  ]),
};
